import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-confirm-reservation-dialog',
  templateUrl: './manual-confirm-reservation-dialog.component.html',
  styleUrls: ['./manual-confirm-reservation-dialog.component.css'],
  standalone: false,
})
export class ManualConfirmReservationDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly comfrmReservationDeiatilDialogLink: string = AppConst.ROUTING_LINK_MANUAL_CONFIRM_RESERVATION_DETAIL_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
